import { render } from "./QwSwitch.vue?vue&type=template&id=0a96553c"
import script from "./QwSwitch.vue?vue&type=script&lang=js"
export * from "./QwSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__